var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Archive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xF0\x9F\x8E\xA8 Color",
    d: "M16.0417 2.5C16.8471 2.5 17.5 3.15292 17.5 3.95833V5.625C17.5 6.20647 17.1597 6.70846 16.6674 6.94266L16.6667 15.2083C16.6667 16.9342 15.2676 18.3333 13.5417 18.3333H6.45833C4.73244 18.3333 3.33333 16.9342 3.33333 15.2083L3.33346 6.94305C2.84069 6.70902 2.5 6.2068 2.5 5.625V3.95833C2.5 3.15292 3.15292 2.5 3.95833 2.5H16.0417ZM15.4167 7.08333H4.58333V15.2083C4.58333 16.2439 5.4228 17.0833 6.45833 17.0833H13.5417C14.5772 17.0833 15.4167 16.2439 15.4167 15.2083V7.08333ZM8.33333 9.58333H11.6667C12.0118 9.58333 12.2917 9.86316 12.2917 10.2083C12.2917 10.5247 12.0565 10.7862 11.7515 10.8276L11.6667 10.8333H8.33333C7.98816 10.8333 7.70833 10.5535 7.70833 10.2083C7.70833 9.89192 7.94346 9.63042 8.24852 9.58904L8.33333 9.58333H11.6667H8.33333ZM16.0417 3.75H3.95833C3.84327 3.75 3.75 3.84327 3.75 3.95833V5.625C3.75 5.74006 3.84327 5.83333 3.95833 5.83333H16.0417C16.1567 5.83333 16.25 5.74006 16.25 5.625V3.95833C16.25 3.84327 16.1567 3.75 16.0417 3.75Z",
    fill: "#1D72E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveBlue);
export default __webpack_public_path__ + "static/media/archive-blue.0ebb4554637d99ad9ad3248e3151a399.svg";
export { ForwardRef as ReactComponent };